import { useEffect, useState, useCallback } from "react";
import { authFetch } from "./auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useSubscription() {
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await authFetch(`${API}/subscription/me`);
      if (res.ok) {
        const data = await res.json();
        setSub(data);
      }
    } catch (e) {
      // silent
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { sub, loading, refresh };
}

export function isLocked(sub) {
  if (!sub) return false;
  return !sub.is_active;
}
